

import React, { Component, useState } from 'react';
import TopFilterData from '../TopFilterData';
import AddFilter from '../../images/filter.png';
import { Dropdown, Spinner } from "react-bootstrap";
import GridHeaderfilter from '../../components/GridHeaderfilter';
import configData from '../../configData.json';
import { useRef } from 'react';
import { addDays, getDate, set } from 'date-fns';
import { useEffect } from 'react';
// import DatePicker from "react-datepicker";

// import "react-datepicker/dist/react-datepicker.css";
import DatePicker from 'react-date-picker';
import moment from 'moment';
import SelectSearch, { fuzzySearch } from 'react-select-search';
import SettingsTopFilterData from './SettingsTopFilterData';

export default function SettingsTopFilter({ oncustom, isAddFilterHidden, criData, isDateDropdownHidden }) {
    // debugger; 
    const [toDate, setToDate] = useState(new Date());
    const [fromDate, setFromDate] = useState(new Date(toDate.getFullYear(), 0, 1, 23, 59, 59));
    const defaultFromValue = fromDate.toISOString().substring(0, 10);
    const defaultToValue = toDate.toISOString().substring(0, 10);
    const [selectedFromDate, setSelectedFromDate] = useState(moment(fromDate).format().substring(0, 10));
    const [selectedToDate, setSelectedToDate] = useState(moment(toDate).format().substring(0, 10));

    const [filterKey, setFilterKey] = useState('');
    const [inputFields, setInputFields] = useState([]);
    const [carriers, setCarriers] = useState([]);
    const [divsions, setDivisions] = useState([]);
    const [selectedOwner, setSelectedOwner] = useState(0);
    const [selectedCust, setSelectedCust] = useState(0);
    const [selectedCarrier, setSelectedCarr] = useState(0);
    const [selectedDivision, setSelectedDivision] = useState(-1);

    const [selectedPastNumOfWeek, setSelectedPastNumOfWeek] = useState(20);
    const [selectedImmediatePastNumWeek, setSelectedImmediatePastNumWeek] = useState(3);
    const [selectedPercentageDecrease, setSelectedPercentageDecrease] = useState(20);
    const [selectedPercentageIncrease, setSelectedPercentageIncrease] = useState(20);

    const [fbNum, setFbNum] = useState("-1");
    const [acctNo, setAcctNo] = useState("-1");

    const [show, setShow] = useState(false);

    const [ownerLoading, isOwnerLoading] = useState(false);
    const [customerLoading, isCustomerLoading] = useState(false);


    let selectedCustRef = useRef(0);
    selectedCustRef.current = selectedCust;

    const [owners, setOwners] = useState([]);
    const [customers, setCustomers] = useState([]);

    function upsert(array, element) { // (1)
        debugger;
        const i = array.findIndex(_element => _element.name === element.name);
        if (i > -1) {
            setInputFields(existingItems => {
                return existingItems.map((item, j) => {
                    // debugger;
                    return j === i ? element : item
                })
            })
            //array[i] = element; // (2)
        }
        else setInputFields([...inputFields, element]);
    }

    const LoadOwner = async () => {
        debugger;
        isOwnerLoading(true);
        const ownerUrl = `${configData.BASE_APP_URL}Owner/GetOwnerList`;
        await fetch(ownerUrl,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            }
        ).then(resp => resp.json())
            .then(resp => {
                let ownerOptions = [];
                resp.map(owner => {
                    const cust = {
                        "name": owner.ownerName,
                        "value": owner.ownerID
                    }
                    ownerOptions = [...ownerOptions, cust];
                })
                const defaultOwner = {
                    "name": "--All Owners--",
                    "value": 0
                }
                ownerOptions.unshift(defaultOwner);
                setOwners(ownerOptions)
            })
        isOwnerLoading(false);
        LoadCustomerDashboard(0);
        // setIsDisabled(props.isDisabled);
    }

    const onOwnerSelect = (e) => {
        debugger;
        var ownerkey = e;
        // if (ownerkey > 0) {
        //     document.getElementById("owner-error").innerHTML = "";
        //     document.getElementById("owner-highlight").innerHTML = "";
        // }
        setSelectedOwner(e);
        setSelectedCust(0);
        LoadCustomerDashboard(e);
        // props.onCustomerChange(custkey);


        oncustom(e, 0, selectedCarrier, selectedFromDate, selectedToDate, fbNum, acctNo);



    };

    const LoadCustomerDashboard = async (ownerKey) => {
        debugger;
        isCustomerLoading(true);
        const custUrl = `${configData.BASE_APP_URL}Customer/GetCustomerList/${ownerKey}`;
        await fetch(custUrl,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            }
        ).then(resp => resp.json())
            .then(resp => {
                let customerOptions = [];
                resp.map(customer => {
                    const cust = {
                        "name": customer.customerName,
                        "value": customer.customerKey
                    }
                    customerOptions = [...customerOptions, cust];
                })
                const defaultCustomer = {
                    "name": "--All Customers--",
                    "value": 0
                }
                customerOptions.unshift(defaultCustomer);
                setCustomers(customerOptions)
            })
        isCustomerLoading(false);
        // setIsDisabled(props.isDisabled);
    }

    const LoadCustomer = async (ownerKey) => {
        const URL = `${configData.BASE_APP_URL}Customer/GetCustomerList/${ownerKey}`;
        await fetch(URL,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            })
            .then(resp => resp.json())
            .then(resp => setCustomers(resp))
    }

    const LoadCarrier = async (customerKey) => {
        // isCarrierLoading(true);
        // setSelectedCust(customerKey);
        const URL = `${configData.BASE_APP_URL}Carrier/GetCarrierList/${customerKey}`;
        await fetch(URL,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            })
            .then(resp => resp.json())
            .then(resp => setCarriers(resp))
        // isCarrierLoading(false);
    }

    const LoadDivision = async (customerKey) => {
        // isCarrierLoading(true);
        // setSelectedCust(customerKey);
        const URL = `${configData.BASE_APP_URL}Division/GetDivisionList/${customerKey}`;
        await fetch(URL,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            })
            .then(resp => resp.json())
            .then(resp => setDivisions(resp))
        // isCarrierLoading(false);
    }
    const handleDChange = async (e) => {
        debugger;
        var value = e.target.value;

        debugger;
        var index = e.nativeEvent.target.selectedIndex;
        var text = e.nativeEvent.target[index].text;
        var key = e.nativeEvent.target[index].value;
        let newfield = { name: filterKey, value: text };
        // upsert(inputFields, newfield);
        var array = [...inputFields];
        switch (filterKey) {
            case 'Owner':
                index = array.findIndex(_element => _element.name === 'Customer');
                if (index !== -1) {
                    array.splice(index, 1);
                    setInputFields(array);
                }

                LoadCustomer(key);
                setSelectedOwner(key);
                setSelectedCust(0);
                if (isDateDropdownHidden === true) {
                    oncustom(key, 0);
                }
                else {
                    oncustom(key, 0, selectedFromDate, selectedToDate);
                }

                break;
            case 'Customer':
                setSelectedCust(key);
                debugger;
                if (isDateDropdownHidden === true) {
                    oncustom(selectedOwner, key);
                }
                else {
                    oncustom(selectedOwner, key, selectedFromDate, selectedToDate);
                }

                break;
            default:
            // code block
        }
        upsert(inputFields, newfield);
        setShow(false);




    }
    const clearHeaderElement = (row) => {
        debugger;
        var array = [...inputFields];
        var index = array.findIndex(_element => _element.name === row.name);
        if (index !== -1) {
            array.splice(index, 1);
            setInputFields(array);
            if (row.name === 'Owner') {
                index = array.findIndex(_element => _element.name === 'Customer');
                if (index !== -1) {
                    array.splice(index, 1);
                    setInputFields(array);
                }               

                if (isDateDropdownHidden === true) {
                    setSelectedCust(-1);
                    LoadCustomer(-1);
                    oncustom(-1, -1);
                }
                else {
                    setSelectedCust(-1);
                    LoadCustomer(-1);
                    oncustom(-1, -1, selectedFromDate, selectedToDate);
                }

            }

            if (row.name === 'Customer') {
                if (isDateDropdownHidden === true) {
                    setSelectedCust(0);
                    oncustom(selectedOwner,0);
                }
                else {
                    setSelectedCust(0);
                    oncustom(selectedOwner, 0, selectedFromDate, selectedToDate);
                }

            }
        }
    }

    const setShowing = (e) => {
        setShow(!show);
    }

    // useEffect(() => {

    //     setShowing();

    // });

    const selectFromDate = (e) => {
        //debugger;
        console.log(e);
        setSelectedFromDate(e.target.value);
        console.log(selectedFromDate);
        oncustom(selectedCust, selectedCarrier, selectedFromDate, selectedToDate, fbNum, acctNo);
    };

    const handleFromDateSelect = (e) => {
        debugger;
        var iYear = e.toLocaleDateString().split('/')[2]

        console.log(iYear);
        console.log(selectedCust);

        // if (selectedCust == 0) {
        //     document.getElementById("filter-error").innerHTML ='Customer is a Required Field, a selection must be made';
        //     return;
        // }

        if (iYear.length === 4) {

            var myFromDate = new Date(moment(e).format().substring(0, 10));
            if (myFromDate.toString() == 'Invalid Date') {
                document.getElementById("filter-error").innerHTML = 'Invalid Date'
                return;
            }

            var today = new Date();

            if (e > today) {
                // document.getElementById("error").innerHTML = "From Entry Date is greater than To Entry Date";
                document.getElementById("filter-error").innerHTML = "From Entry Date is greater than Current Date";
                return;
            }
            else if (e > toDate) {
                // document.getElementById("error").innerHTML = "From Entry Date is greater than To Entry Date";
                document.getElementById("filter-error").innerHTML = "From Entry Date is greater than To Entry Date";
                return;
            }
            else {
                document.getElementById("filter-error").innerHTML = "";
            }

            setFromDate(e);
            setSelectedFromDate(moment(e).format().substring(0, 10));

            oncustom(selectedOwner, selectedCust, moment(e).format().substring(0, 10), selectedToDate);


        }
        // }

    };

    const handleToDateSelect = (e) => {
        debugger;

        var myToDate = new Date(moment(e).format().substring(0, 10));
        if (myToDate.toString() == 'Invalid Date') {
            document.getElementById("filter-error").innerHTML = 'Invalid Date'
            return;
        }

        var today = new Date();
        if (e > today) {
            // document.getElementById("error").innerHTML = "From Entry Date is greater than To Entry Date";
            document.getElementById("filter-error").innerHTML = "To Entry Date is greater than Current Date";
            return;
        }
        if (e < fromDate) {
            // document.getElementById("error").innerHTML = "From Entry Date is greater than To Entry Date";
            document.getElementById("filter-error").innerHTML = "To Entry Date is lesser than From Entry Date";
            return;
        }
        else {
            document.getElementById("filter-error").innerHTML = "";
        }

        setToDate(e);
        setSelectedToDate(moment(e).format().substring(0, 10));
        
        oncustom(selectedOwner, selectedCust, selectedFromDate, moment(e).format().substring(0, 10));
    };

    const selectToDate = (e) => {
        setSelectedToDate(e.target.value)
        oncustom(selectedCust, selectedCarrier, selectedFromDate, selectedToDate, fbNum, acctNo);

    };

    const onCustomerSelect = (e) => {
        // debugger;
        var custkey = e;
        setSelectedCust(custkey);
        oncustom(selectedOwner, custkey, selectedCarrier, selectedFromDate, selectedToDate, fbNum, acctNo);

        // LoadCarrier(e);
        // props.onCustomerChange(custkey);

    };

    useEffect(() => {
        if (isAddFilterHidden == true) {
            LoadOwner();
        }
    }, [])


    return (
        <>

            <div className='top-filter-container mb-1 border rounded-1 p-1 d-flex align-items-center flex-wrap'>
                <div hidden={isDateDropdownHidden}>
                    <Dropdown>
                        <Dropdown.Toggle variant="default" id="dropdown-basic2">
                            <button className='btn p-0'>
                                <div className='filter-result bg-white p-1 border rounded-1 me-1 d-flex align-items-center'>
                                    <span className=''>Entry Date : {moment(selectedFromDate).format('L')} - {moment(selectedToDate).format('L')} </span>
                                    {/* <a href='#' className='me-1'><i className="ic fa fa-close"></i></a> */}
                                </div>
                            </button>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <div className='filter-item  bg-white p-1'>
                                <div id="filter-error" className="text-danger"></div>
                                <div className='d-flex'>
                                    <div className="form-field me-2">
                                        <label>From Entry Date</label>
                                        <div>
                                            {/* <input type="date" className="form-control form-control-sm" defaultValue={defaultFromValue} onChange={selectFromDate} ></input> */}
                                            <DatePicker className="" value={fromDate} onChange={handleFromDateSelect} calendarIcon={<i className='fas fa-calendar-alt'></i>} format="MM/dd/yyyy" />
                                        </div>
                                    </div>
                                    <div className="form-field">
                                        <label>To Entry Date</label>
                                        <div>
                                            {/* <input type="date" className="form-control form-control-sm" defaultValue={defaultToValue} onChange={selectToDate}></input> */}
                                            <DatePicker className="" value={toDate} onChange={handleToDateSelect} calendarIcon={<i className='fas fa-calendar-alt'></i>} format="MM/dd/yyyy" />
                                        </div>
                                    </div>
                                    {/* <button className='close-filter'><i class="fas fa-times"></i></button> */}
                                </div>
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <GridHeaderfilter populatedata={inputFields} cleardata={clearHeaderElement}></GridHeaderfilter>
                <Dropdown show={show}>
                    <Dropdown.Toggle variant="default" id="dropdown-basic">
                        <button className='btn btn-add-filter' onClick={setShowing} hidden={isAddFilterHidden}><img src={AddFilter}></img>Add Filter</button>
                    </Dropdown.Toggle>
                    {show
                        ? <Dropdown.Menu>
                            <div className='filter-item  bg-white p-1'>
                                <SettingsTopFilterData filterkey={setFilterKey} carrierData={carriers} customerData={customers} onChange={handleDChange} criData={criData} divisionData={divsions} />
                            </div>
                        </Dropdown.Menu>
                        :
                        null
                    }
                </Dropdown>
                {isAddFilterHidden
                    ?
                    <div className="p-2">
                        <SelectSearch
                            width="300px"

                            id="ddnOwner"
                            name="ddnOwner"
                            // value={props.topFilterCustKey != '' ? props.topFilterCustKey : selectedCust}
                            value={selectedOwner}
                            options={owners}
                            onChange={onOwnerSelect}
                            search
                            filterOptions={fuzzySearch}
                        >
                        </SelectSearch>
                    </div>
                    :
                    null
                }
                {isAddFilterHidden
                    ? <SelectSearch
                        width="300px"
                        id="ddnCustomer"
                        name="ddnCustomer"
                        // value={props.topFilterCustKey != '' ? props.topFilterCustKey : selectedCust}
                        value={selectedCust}
                        options={customers}
                        onChange={onCustomerSelect}
                        search
                        filterOptions={fuzzySearch}
                    >
                    </SelectSearch>

                    :
                    null
                }
                {customerLoading ? <Spinner className='spinner-border spinner-border-topfilter' animation="border" variant="primary" /> : customerLoading}


            </div>



        </>

    )
}
